// Frans (fr-FR), languagesApp: zelfde vorm als languagesApp.nl.ts. "Arabische cijfers" zijn hier
// de oosters-Arabische cijfers (٠١٢); in het Frans zijn "chiffres arabes" gewoon 0-9.
export const appLanguagesFr = {
    title: 'Langue',
    settingsBody: 'La langue de l’appli, des tablettes et des e-mails',
    welcomeTitle: 'Bienvenue. Quelle langue parle-t-on chez toi ?',
    welcomeBody: 'Choisis la langue de ta famille. Tu peux toujours la changer plus tard dans Réglages.',
    continue: 'Continuer',
    household: 'Langue de la famille',
    householdHint: 'Pour l’appli, les tablettes et les e-mails. Chaque membre de la famille et chaque tablette suit cette langue, sauf si tu choisis autre chose.',
    saved: 'Langue enregistrée',
    partial: 'Tout n’est pas encore traduit. Ce qui manque s’affiche en néerlandais.',
    digitsTitle: 'Chiffres',
    digitsLatin: 'Chiffres habituels',
    digitsArabic: 'Chiffres arabes orientaux',
    digitsHint: 'Pour les heures et les nombres, sur les tablettes et dans l’appli.',
    overridesTitle: 'Une langue à part',
    overridesBody: 'Quelqu’un préfère une autre langue, ou une tablette est dans une chambre ? Choisis-le dans Famille et dans Tablettes.',
    overridesOff: 'La langue par personne ou par tablette est désactivée. Tu peux l’activer dans Modules.',
    toMembers: 'Aller à Famille',
    toDevices: 'Aller à Tablettes',
    sameAsFamily: 'Comme la famille ({language})',
    memberLabel: 'Langue',
    memberHint: 'Pour l’appli et les e-mails de {name}.',
    deviceLabel: 'Langue de cette tablette',
    deviceHint: 'Pratique pour une tablette dans une chambre. Sinon, elle suit la famille.',
    deviceSaved: '{name} parle maintenant {language}',
    ownLanguage: 'Parle {language}',
    authLabel: 'Langue',
};
//# sourceMappingURL=languagesApp.fr.js.map